import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

// The WhatsApp bridge mirrors the AI's replies through a regular agent account
// (CHATWOOT_BOT_AGENT_EMAIL), so that agent's messages are the assistant's.
export function useAiAssistant() {
  const globalConfig = useMapGetter('globalConfig/get');
  const agents = useMapGetter('agents/getAgents');

  const aiAgentId = computed(() => {
    const { aiAgentEmail } = globalConfig.value;
    if (!aiAgentEmail) return null;
    return agents.value.find(agent => agent.email === aiAgentEmail)?.id ?? null;
  });

  return { aiAgentId };
}
